import React from "react";
import FadeIn from "react-fade-in";
import LoadAnim from "../App/LoadAnim.js";

export class Seatmap extends React.Component {
  _mounted = false;
  constructor(props) {
    super(props);

    this.clickedOnSeat = this.clickedOnSeat.bind(this);
    this.getSeatData = this.getSeatData.bind(this);

    this.updateSeats = this.updateSeats.bind(this);
    this.isReservedByMe = this.isReservedByMe.bind(this);
    this.tooManyClicked = this.tooManyClicked.bind(this);
    this.seatsToReserve = this.seatsToReserve.bind(this);
    this.goToConfirm = this.goToConfirm.bind(this);
    this.setSelectedSeats = this.setSelectedSeats.bind(this);
    this.setSelectedSeatObjs = this.setSelectedSeatObjs.bind(this);
    this.BackButton = this.BackButton.bind(this);
    this.primeConnection = this.primeConnection.bind(this);
    this.postSeats = this.postSeats.bind(this);

    //We fill state from backend
    this.state = {
      rows: [],

      selectedSeats: [],

      selectedSeatObjs: [],

      timeStamp: 0,
      timeToStop: 0,
      timeLeft: 0,

      locked: false,
      skipRequest: false,
      seat: {},
      disabled: false
    };
  }

  componentWillMount() {
    this._mounted = true;
    if (this.props.selectedSeats !== undefined) {
      this.setState({ selectedSeats: this.props.selectedSeats });
    }

    if (this.props.selectedSeatObjs !== undefined) {
      this.setState({ selectedSeatObjs: this.props.selectedSeatObjs });
    }

    if (this.props.timeStamp !== undefined) {
      this.setState({ timeStamp: this.props.timeStamp });
    }

    if (this.props.timeToStop !== undefined) {
      this.setState({ timeToStop: this.props.timeToStop });
    }

    if (this.props.timeLeft !== undefined) {
      this.setState({ timeLeft: this.props.timeLeft });
    }
  }

  componentDidMount() {
    this.getSeatData();
    this.interval = setInterval(() => this.updateSeats(), 2500);
    //this.primeConnection();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this._mounted = false;
  }

  primeConnection() {
    fetch("/api/seating/holdSeats/" + this.props.guid, {
      method: "PUT",
      body: JSON.stringify(""),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        pragma: "no-cache",
        "cache-control": "no-cache"
      }
    });
    return;
  }

  //We refresh the seat-data every X seconds.
  updateSeats() {
    if (this._mounted === true) {
      if (this.state.skipRequest === false) {
        this.getSeatData();
      }
      this.forceUpdate();
    }
  }

  //We grab the seat JSON from backend
  async getSeatData() {
    this.setState({ skipRequest: true });
    //If tab is not visible, we just stop it
    if (this.props.visibility === false) {
      console.log("Tab not in focus");
      this.setState({ skipRequest: false });
      return;
    }

    if (this._mounted === true) {
      let myHeaders = new Headers();
      myHeaders.append("pragma", "no-cache");
      myHeaders.append("cache-control", "no-cache");

      let myInit = {
        method: "GET",
        headers: myHeaders
      };

      let response = await fetch(
        "/api/seating/getseats/" + this.props.guid,
        myInit
      )
        .then(function(response) {
          return response.json();
        })
        .catch(error => {
          console.error("Error:", error);
          setTimeout(() => {
            this.updateSeats();
          }, 8000);
        });

      await this.setState({ rows: response });
      await this.setState({ skipRequest: false });
      await this.forceUpdate();
    }
  }

  //If user clicks on seat
  async clickedOnSeat(seat) {
    if (seat.reserver !== null && seat.reserver !== this.props.guid.slice(-6)) {
      return null;
    }

    // Check if seat is blocked
    if (seat.isBlocked) {
      return null;
    }

    if (this.state.disabled === true) {
      return;
    } else {
      await this.setState({ disabled: true });
    }

    seat.rownum = parseInt(seat.rownum, 10);
    seat.number = parseInt(seat.number, 10);

    this.setState({ locked: true });

    console.log(
      "row:" +
        seat.rownum +
        " seat:" +
        seat.number +
        " Timestamp: " +
        seat.timestamp
    );
    let seatIdentity = "s" + seat.number + "r" + seat.rownum;

    //Check if we already have this seat in the array
    let existsInArray = this.state.selectedSeats.indexOf(seatIdentity);

    if (seat.isReserved === "held" && existsInArray === -1) {
      console.log("Already held by someone else");
      await this.setState({ disabled: false });
      return;
    }

    //We check for deletion if item already exists in array
    if (existsInArray !== -1) {
      let filteredArray = this.state.selectedSeats.filter(
        item => item !== seatIdentity
      );

      const filteredSeatObjs = this.state.selectedSeatObjs.filter(
        seatObj => !(seatObj.rownum === seat.rownum && seatObj.number === seat.number)
      );

      this.setState({
        selectedSeats: filteredArray,
        selectedSeatObjs: filteredSeatObjs
      });

      this.setSelectedSeatObjs(filteredSeatObjs);

      seat.isReserved = "no"; //We set the status back
      seat.timestamp = "none";

      console.log("Deleting " + seatIdentity);

      if (this.state.selectedSeats.length <= 0) {
        this.props.SetTimes(0, 0, 0);
      }

      await this.getSeatData(); //refresh
    }

    //Push to "bucket" to keep track of how many seats are being reserved
    else if (this.state.selectedSeats.length < this.props.setNumPersons) {
      if (seat.isReserved === "no") {
        seat.isReserved = "held";
        seat.reserver = this.props.guid.slice(-6);

        this.setState(prevState => ({
          selectedSeats: [...prevState.selectedSeats, seatIdentity],
          selectedSeatObjs: [...prevState.selectedSeatObjs, seat]
        }));
      }
    } else {
      console.log("You cannot select additional seats");

      await this.getSeatData();
      setTimeout(this.setState({ locked: false }), 400);
      await this.setState({ disabled: false });
      return;
    }

    this.setSelectedSeats(this.state.selectedSeats);
    this.setSelectedSeatObjs(this.state.selectedSeatObjs);

    this.forceUpdate();

    let status = await this.postSeats(seat, seatIdentity);
    if (status !== 200) {
      const filteredSeatObjs = this.state.selectedSeatObjs.filter(
        seatObj => !(seatObj.rownum === seat.rownum && seatObj.number === seat.number)
      );
      let filteredArray = this.state.selectedSeats.filter(
        item => item !== seatIdentity
      );

      this.setState({
        selectedSeats: filteredArray,
        selectedSeatObjs: filteredSeatObjs
      });
      if (status === 403) {
        seat.isReserved = "no";
        await this.postSeats(seat, seatIdentity);
      }
      await this.setState({ disabled: false });
      return;
    }
    clearInterval(this.interval);
    await setTimeout(this.getSeatData, 200);
    this.interval = setInterval(() => this.updateSeats(), 2500);
    setTimeout(this.setState({ locked: false }), 400);

    if (this.props.timeStamp === 0 && seat.isReserved === "held") {
      this.props.SetTimer(
        this.state.selectedSeats,
        this.state.selectedSeatObjs
      );
    }

    await setTimeout(() => {
      this.setState({ disabled: false });
    }, 1000);
    return false;
  }

  async postSeats(seat, seatIdentity) {
    //Post/put to backend and refresh again
    let status = await fetch("/api/seating/holdSeats/" + this.props.guid, {
      method: "PUT",
      body: JSON.stringify(seat),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        pragma: "no-cache",
        "cache-control": "no-cache"
      }
    })
      .then(response => {
        return response.status;
      })
      .catch(e => {
        console.log(e);
        alert("Noe gikk galt med din påmelding. Vennligst prøv igjen");
        this.setState({ disabled: false });
        this.props.goBack();
      });

    return status;
  }

  //We check if the user has reserved to set custom color
  isReservedByMe(seat) {
    let seatIdentity = "s" + seat.number + "r" + seat.rownum;
    let exists = this.state.selectedSeats.indexOf(seatIdentity);
    if (seat.reserver !== this.props.guid.slice(-6)) {
      return false;
    }

    if (exists !== -1) {
      return true;
    } else {
      return false;
    }
  }

  tooManyClicked() {
    return this.state.selectedSeats.length < this.props.setNumPersons;
  }

  seatsToReserve() {
    let seats = this.props.setNumPersons - this.state.selectedSeats.length;

    if (seats === 1) {
      return "Du har " + seats + " plass igjen å reservere";
    } else {
      return "Du har " + seats + " plasser igjen å reservere";
    }
  }

  goToConfirm(e) {
    this._mounted = false;

    // Check for duplicate seats within the same order
    const seenSeats = new Set();
    const duplicateSeats = [];
    
    for (let i = 0; i < this.state.selectedSeatObjs.length; i++) {
      const seat = this.state.selectedSeatObjs[i];
      const seatKey = `${seat.rownum}-${seat.number}`;
      
      if (seenSeats.has(seatKey)) {
        duplicateSeats.push(`Row ${seat.rownum}, Seat ${seat.number}`);
      } else {
        seenSeats.add(seatKey);
      }
      
      if (
        seat.reserver !== this.props.guid.slice(-6) &&
        seat.reserver !== null
      ) {
        this.props.goBack();
        return;
      }
    }

    // If duplicates found, alert user and don't proceed
    if (duplicateSeats.length > 0) {
      alert(`Duplicate seats detected: ${duplicateSeats.join(', ')}. Please refresh the page and try again.`);
      this.props.goBack();
      return;
    }

    this.setSelectedSeatObjs(this.state.selectedSeatObjs);
    this.setSelectedSeats(this.state.selectedSeats);
    setTimeout(this.props.goToConfirm(e), 400);
  }

  setSelectedSeats(e) {
    this.props.setSelectedSeats(e);
  }

  setSelectedSeatObjs(e) {
    this.props.setSelectedSeatObjs(e);
  }

  BackButton(e) {
    if (this.state.selectedSeatObjs.length === 0) {
      this.props.goBack();
    } else {
      let selectedSeatObjsHolder = this.state.selectedSeatObjs;

      for (let i = 0; i < selectedSeatObjsHolder.length; i++) {
        if (selectedSeatObjsHolder[i].reserver === this.props.guid.slice(-6)) {
          selectedSeatObjsHolder[i].isReserved = "no";
        }
      }
      this.setState({ selectedSeatObjs: selectedSeatObjsHolder });

      this.setSelectedSeatObjs(this.state.selectedSeatObjsHolder);
      this.setSelectedSeats(this.state.selectedSeats);

      this.props.PostSeats(this.state.selectedSeatObjs);

      this.props.goBack();
    }
  }

  render() {
    let rows = this.state.rows;
    let row1 = [];
    let row2 = [];
    let row3 = [];
    let row4 = [];
    let row5 = [];
    let row6 = [];
    let row7 = [];
    let row8 = [];
    let row9 = [];
    let row10 = [];

    if (this.state.rows !== undefined && this.state.rows !== null) {
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].rownum === 1) {
          row1.push(rows[i]);
        }
        if (rows[i].rownum === 2) {
          row2.push(rows[i]);
        }
        if (rows[i].rownum === 3) {
          row3.push(rows[i]);
        }
        if (rows[i].rownum === 4) {
          row4.push(rows[i]);
        }
        if (rows[i].rownum === 5) {
          row5.push(rows[i]);
        }
        if (rows[i].rownum === 6) {
          row6.push(rows[i]);
        }
        if (rows[i].rownum === 7) {
          row7.push(rows[i]);
        }
        if (rows[i].rownum === 8) {
          row8.push(rows[i]);
        }
        if (rows[i].rownum === 9) {
          row9.push(rows[i]);
        }
        if (rows[i].rownum === 10) {
          row10.push(rows[i]);
        }
      }
    }

    let seatList = [];

    if (this.state.selectedSeats.length > 0) {
      for (let i = 0; i < this.state.selectedSeats.length; i++) {
        let row = this.state.selectedSeats[i].substring(
          this.state.selectedSeats[i].lastIndexOf("r") + 1
        );

        let seat = this.state.selectedSeats[i].substring(
          this.state.selectedSeats[i].lastIndexOf("s") + 1,
          this.state.selectedSeats[i].lastIndexOf("r")
        );
        if (this.state.selectedSeatObjs[i] !== undefined) {
          seatList.push(
            <div className="seatListItem" key={seat + row}>
              {" "}
              <button
                onClick={this.clickedOnSeat.bind(this, {
                  rownum: row,
                  number: seat,
                  isReserved: "held",
                  reserver: this.state.selectedSeatObjs[i].reserver,
                  timestamp: this.state.selectedSeatObjs[i].timestamp
                })}
                className="btn btn-danger help seatListBtn"
              >
                X
              </button>{" "}
              Rad: {row} Plass: {seat}{" "}
            </div>
          );
        } else {
          let arr = this.state.selectedSeats;
          const index = this.state.selectedSeats[i];
          arr.splice(index, 1);
          seatList.splice(-1, 1);
        }
      }
    }

    return (
      <div>
        {(this.state.rows === undefined ||
          this.state.rows === null ||
          this.state.rows.length === 0) && <LoadAnim />}
        {this.state.rows !== undefined &&
          this.state.rows !== null &&
          this.state.rows.length !== 0 && (
            <FadeIn>
              <div
                className={
                  "col-centered seatContainer " +
                  (this.state.disabled ? "cover" : "")
                }
              >
                <div className="numSeatsToReserve">
                  <h4> {this.seatsToReserve()} </h4>
                  <p> </p>
                </div>

                <div className="tribune">Tribune</div>
                <div className="rowDivider"></div>

                <div className="row seatRow">
                  <h4 className="rowNum">1</h4>
                  {row1.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">1</h4>
                </div>

                <div className="row seatRow">
                  <h4 className="rowNum">2</h4>
                  {row2.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">2</h4>
                </div>

                <div className="rowDivider"> </div>

                <div className="row seatRow">
                  <h4 className="rowNum">3</h4>
                  {row3.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">3</h4>{" "}
                </div>

                <div className="row seatRow">
                  <h4 className="rowNum">4</h4>
                  {row4.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">4</h4>{" "}
                </div>

                <div className="rowDivider"> </div>

                <div className="row seatRow">
                  <h4 className="rowNum">5</h4>
                  {row5.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">5</h4>{" "}
                </div>

                <div className="row seatRow">
                  <h4 className="rowNum">6</h4>
                  {row6.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">6</h4>{" "}
                </div>

                <div className="rowDivider"> </div>

                <div className="row seatRow">
                  <h4 className="rowNum">7</h4>
                  {row7.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">7</h4>{" "}
                </div>

                <div className="row seatRow">
                  <h4 className="rowNum">8</h4>
                  {row8.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">8</h4>{" "}
                </div>

                <div className="rowDivider"> </div>

                <div className="row seatRow">
                  <h4 className="rowNum">9</h4>
                  {row9.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">9</h4>{" "}
                </div>

                <div className="row seatRow">
                  <h4 className="rowNum">10</h4>
                  {row10.map((seat, index) => (
                    <div
                      key={index}
                      title={
                        (seat.isBlocked ? "Blokkert" : "") ||
                        (seat.isReserved.match("no") ? "Ledig" : "") ||
                        (seat.isReserved.match("yes") ? "Reservert" : "") ||
                        (seat.isReserved.match("held") ? "Holdes av" : "")
                      }
                      className={
                        "btn seatBox " +
                        ((seat.isBlocked ? "blocked-seat " : "") ||
                          (this.isReservedByMe(seat) ? "mySeat " : "") ||
                          (seat.isReserved.match("no")
                            ? "btn-info open "
                            : "") ||
                          (seat.isReserved.match("yes") ? "taken " : "") ||
                          (seat.isReserved.match("held") ? "held " : ""))
                      }
                      onClick={() => {
                        if (!seat.isBlocked) {
                          this.clickedOnSeat(seat);
                        }
                      }}
                    >
                      {seat.number}
                    </div>
                  ))}
                  <h4 className="rowNum">10</h4>
                </div>

                <div className="projector">Projector</div>

                <div className="seatListContainer">
                  {this.state.selectedSeats.length > 0 &&
                    this.props.timeLeft !== 0 && (
                      <div className="seatList">
                        <h4> Dine Plasser: </h4>
                        {seatList}
                        <p> </p>
                        <h4> Tid igjen: </h4>
                        {this.props.timeLeft}
                      </div>
                    )}

                  {this.state.selectedSeats.length > 0 && <div />}

                  <div className="goToPayment">
                    <button
                      className="btn btno btn-danger help"
                      onClick={this.BackButton}
                    >
                      Tilbake
                    </button>
                    {this.state.selectedSeats.length -
                      this.props.setNumPersons ===
                      0 && (
                      <button
                        disabled={this.state.locked}
                        className="btn btno btn-info help"
                        onClick={this.setSelectedSeats && this.goToConfirm}
                      >
                        Til bekreftelse{" "}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </FadeIn>
          )}
      </div>
    );
  }
}

export default Seatmap;



// WEBPACK FOOTER //
// ./src/Components/Signup/Seatmap.js